import React from "react";
import { Component } from "react";
import { Link } from "react-router-dom";
import { withRouter } from "react-router-dom";
import {
  getFromLocalStorage,
  setInToLocalStorage,
} from "../../../utils/webStorage";
import AuthService from "../../../services/auth.service";
import backIcon from "../../../assets/images/public/back-icon.png";
import { ReactComponent as ContendZONE } from "../../../assets/images/contendZONEone.svg";
import { MessageAlert, Spinner } from "../..";
import { LoginForm } from "./loginForm";
import { emailAddress } from "../../../common";
import { setLoggedInUserInformation } from "../../../Redux/Actions/LoginActions";
import { connect } from "react-redux";
import userService from "../../../services/user.service";
import { fullPageLoading } from "../../../Redux/Actions/LoadingActions";

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      password: "",
      deviceId: "",
      errorMessage: "",
      loading: false,
      visible: false,
      disabled: false,
    };
  }

  submitLogin = (values) => {
    const { email, password, captchaValue } = values;
    const { deviceId } = this.state;
    const { history, fullPageLoading, userInfo } = this.props;
    this.setErrorLoading("", true);
    const fcmToken = null;
    fullPageLoading(true);
    AuthService.login(email, password, fcmToken, deviceId, captchaValue)
      .then((response) => {
        if (response.success === false) {
          this.handleCloseMessageBox(true);
          this.setErrorLoading(response?.data || "Something went wrong", false);
          this.setState({ disabled: true });
          fullPageLoading(false);
        } else {
          const role = response.roles[0].role;
          this.props.setLoggedInUser({ ...response, role: role });
          const currentLoggedId = response.roles[0].id;
          const currentUserId = response.userProfile.userId;
          const assignedRights = response.userProfile.permissionRights;
          localStorage.setItem("currentUserId", currentUserId);
          localStorage.setItem("currentLoggedId", currentLoggedId);
          localStorage.setItem(
            "assignedRights",
            JSON.stringify(assignedRights)
          );
          this.setState({ disabled: false });
          this.handleCloseMessageBox(false);
          this.setErrorLoading("", false);

          if (role === "ROLE_SUPER_ADMIN") {
            history.push("/superAdminDashboard");
            localStorage.setItem("superAdminEmail", response.userProfile.email);
            fullPageLoading(false);
          } else if (role === "ROLE_SCHOOL_ADMIN") {
            history.push("/schooladmindata");
            const loginSchoolId = response.school.id;
            if (response.school.uploadedLogo != null) {
              var schoolProfilePic = response.school.uploadedLogo.filePath;
              setInToLocalStorage("loginUserProfile", schoolProfilePic);
            }
            localStorage.setItem("schoolId", loginSchoolId);
            fullPageLoading(false);
          } else if (role === "ROLE_COACH" || role === "ROLE_TEAM_ADMIN") {
            let id;

            if (role === "ROLE_TEAM_ADMIN") {
              id = response.teamAdmin.id;
              userService
                .getTeamAdminSchoolDetails(id)
                .then((response) => {
                  const data = response.data.data;
                  const coachName = data.teamAdmin.firstName;
                  let coachProfilePic;
                  let schoolSendLogo;
                  if (data.teamAdmin.uploadedLogo != null) {
                    coachProfilePic = data.teamAdmin.uploadedLogo.filePath;
                    setInToLocalStorage("loginUserProfile", coachProfilePic);
                  }
                  const schoolDetails = data.schools;
                  this.setState({ coachName, coachProfilePic, schoolDetails });
                  const schoolToSendId = schoolDetails[0].id;
                  const schoolToSendName = schoolDetails[0].schoolName;
                  if (schoolDetails[0].uploadedLogo != null) {
                    schoolSendLogo = schoolDetails[0].uploadedLogo.filePath;
                  }
                  this.getSelectedSchoolId(
                    schoolToSendId,
                    schoolToSendName,
                    schoolSendLogo,
                    "teamadmin"
                  );
                })
                .catch((error) => {
                  console.error("There was an error!", error);
                });
            } else {
              id = response.coach.id;
              userService
                .getCoachSchoolDetails(id)
                .then((response) => {
                  const data = response.data.data;
                  const coachName = data.coach.firstName;
                  let coachProfilePic;
                  let schoolSendLogo;
                  if (data.coach.uploadedLogo != null) {
                    coachProfilePic = data.coach.uploadedLogo.filePath;
                    setInToLocalStorage("loginUserProfile", coachProfilePic);
                  }
                  const schoolDetails = data.schools;
                  this.setState({ coachName, coachProfilePic, schoolDetails });
                  if (schoolDetails.length < 2) {
                    const schoolToSendId = schoolDetails[0].id;
                    const schoolToSendName = schoolDetails[0].schoolName;
                    if (schoolDetails[0].uploadedLogo != null) {
                      schoolSendLogo = schoolDetails[0].uploadedLogo.filePath;
                    }
                    this.getSelectedSchoolId(
                      schoolToSendId,
                      schoolToSendName,
                      schoolSendLogo,
                      "coach"
                    );
                  }
                })
                .catch((error) => {
                  console.error("There was an error!", error);
                });
            }
            localStorage.setItem("coachId", id);
          } else if (role === "ROLE_ATHLETE") {
            const loginAtheleteIdId = response.athlete.id;
            if (response.athlete.uploadedLogo != null) {
              var atheleteProfile = response.athlete.uploadedLogo.filePath;
              setInToLocalStorage("loginUserProfile", atheleteProfile);
            }
            localStorage.setItem("athleteId", loginAtheleteIdId);
            history.push("/athletedashboard");
            fullPageLoading(false);
          }
        }
      })
      .catch((err) => {
        console.error(err);
        this.setErrorLoading("Your Account is Inactive", false);
        fullPageLoading(false);
        this.handleCloseMessageBox(true);
      });
  };

  setErrorLoading = (errorMessage, loading) =>
    this.setState({
      errorMessage,
      loading,
    });

  handleCloseMessageBox = (visible) => this.setState({ visible });

  getSelectedSchoolId = (id, name, filepath, role) => {
    const { fullPageLoading } = this.props;
    const { history } = this.props;
    localStorage.setItem("schoolId", id);
    localStorage.setItem("schoolName", name);
    localStorage.setItem("schoolLogo", filepath);
    history.push(role === "coach" ? "/coachdashboard" : "/teamadmindashboard");
    fullPageLoading(false);
  };

  render() {
    const { loading, errorMessage, visible } = this.state;

    return (
      <div className="position-relative">
        <section className="guidlelines-section login-section">
          <div className="guidlelines-container contact-us-container">
            <Link to="/">
              <ContendZONE id="mainlogo1" />
            </Link>
            <div className="contact-us-content signup-contnet">
              <div className="screen-title-container">
                <div className="screen-title-content">
                  <Link className="back-button-container" to="/">
                    <img src={backIcon} alt="back" />
                  </Link>
                </div>
              </div>
              <div className="faq-section pd-5">
                <div className="login-title semi-bold">
                  Enter your details to Log-In
                </div>
                <div>
                  <LoginForm submitLogin={this.submitLogin} />
                </div>
              </div>
            </div>
            <div className="not-registered">
              To know more about our products
              <Link className="forgot-link-container" to="/signup">
                <div>Sign Up</div>
              </Link>
            </div>
          </div>
          <div className="login-footer">
            <div>
              Copyright © {new Date().getFullYear()} - All rights reserved |
              CONTENDZONE | Disclaimer | Privacy Policy
            </div>
            <div>{emailAddress}</div>
          </div>
        </section>
        <MessageAlert
          message={errorMessage}
          handleCloseMessageBox={() => this.handleCloseMessageBox(false)}
          open={visible}
          color="red"
        />
      </div>
    );
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    setLoggedInUser: (userInfo) =>
      setLoggedInUserInformation(dispatch, userInfo),
    fullPageLoading: (obj) => fullPageLoading(dispatch, obj),
  };
};

const mapStateToProps = (state) => {
  return {
    userInfo: state,
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Login));
